import React, { Component } from 'react';
import { Spin } from 'antd';
import PropTypes from 'prop-types';

import GridWithCard from './GridWithCard';
import withInfiniteScroll from './withInfiniteScroll';

/**
 * Define prop types
 *
 * @param { object } context
 */
const propTypes = {
  context: PropTypes.shape({
    applicationToken: PropTypes.string,
    scope: PropTypes.string,
    customerId: PropTypes.number,
    contractId: PropTypes.number,
  }),
  handleModal: PropTypes.func,
  handleCheckBox: PropTypes.func,
  getData: PropTypes.func,
  reset: PropTypes.bool,
};

/**
 * Define default props
 *
 * @param { object } context
 */
const defaultProps = {
  context: {},
  handleModal: () => {},
  handleCheckBox: () => {},
  getData: () => {},
  reset: false,
};

/**
 * GridImageRecognition component
 * @example <GridImageRecognition />
 */
class GridImageRecognition extends Component {
  constructor(props) {
    super(props);
    this.state = {
      reset: false,
    };

    this.ImageRecognitionGrid = withInfiniteScroll(componentProps => {
      const { ...otherProps } = componentProps;
      return (
        <GridWithCard
          context={props.context}
          handleModal={this.props.handleModal}
          handleCheckBox={this.props.handleCheckBox}
          {...otherProps}
        />
      );
    });
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.reset !== prevState.reset) {
      return { reset: nextProps.reset };
    }
    return null;
  }

  shouldComponentUpdate(nextProps, nextState) {
    return nextState.reset;
  }

  render() {
    const ImageRecognitionGrid = this.ImageRecognitionGrid;

    return (
      <ImageRecognitionGrid
        className="enhanced-grid-inner"
        context={this.props.context}
        data={this.props.data}
        fetchMoreData={this.props.fetchMoreData}
        getData={this.props.getData}
        loading={<Spin size="large" />}
        pageSize={20}
        reset={this.state.reset}
        userAction={this.props.userAction}
      />
    );
  }
}

GridImageRecognition.defaultProps = defaultProps;
GridImageRecognition.propTypes = propTypes;

export default GridImageRecognition;
